import gamePieceAsteriskA01 from '../images/game-piece-asterisk-A-01.png';
import gamePieceAsteriskA02 from '../images/game-piece-asterisk-A-02.png';
import gamePieceAsteriskA03 from '../images/game-piece-asterisk-A-03.png';
import gamePieceAsteriskA04 from '../images/game-piece-asterisk-A-04.png';
import gamePieceAsteriskA05 from '../images/game-piece-asterisk-A-05.png';
import gamePieceAsteriskA06 from '../images/game-piece-asterisk-A-06.png';
import gamePieceAsteriskA07 from '../images/game-piece-asterisk-A-07.png';
import gamePieceAsteriskA08 from '../images/game-piece-asterisk-A-08.png';
import gamePieceAsteriskB01 from '../images/game-piece-asterisk-B-01.png';
import gamePieceAsteriskB02 from '../images/game-piece-asterisk-B-02.png';
import gamePieceAsteriskB03 from '../images/game-piece-asterisk-B-03.png';
import gamePieceAsteriskB04 from '../images/game-piece-asterisk-B-04.png';
import gamePieceAsteriskB05 from '../images/game-piece-asterisk-B-05.png';
import gamePieceAsteriskB06 from '../images/game-piece-asterisk-B-06.png';
import gamePieceAsteriskB07 from '../images/game-piece-asterisk-B-07.png';
import gamePieceAsteriskB08 from '../images/game-piece-asterisk-B-08.png';
import gamePieceAsteriskC01 from '../images/game-piece-asterisk-C-01.png';
import gamePieceAsteriskC02 from '../images/game-piece-asterisk-C-02.png';
import gamePieceAsteriskC03 from '../images/game-piece-asterisk-C-03.png';
import gamePieceAsteriskC04 from '../images/game-piece-asterisk-C-04.png';
import gamePieceAsteriskC05 from '../images/game-piece-asterisk-C-05.png';
import gamePieceAsteriskC06 from '../images/game-piece-asterisk-C-06.png';
import gamePieceAsteriskC07 from '../images/game-piece-asterisk-C-07.png';
import gamePieceAsteriskC08 from '../images/game-piece-asterisk-C-08.png';
import gamePieceAsteriskD01 from '../images/game-piece-asterisk-D-01.png';
import gamePieceAsteriskD02 from '../images/game-piece-asterisk-D-02.png';
import gamePieceAsteriskD03 from '../images/game-piece-asterisk-D-03.png';
import gamePieceAsteriskD04 from '../images/game-piece-asterisk-D-04.png';
import gamePieceAsteriskD05 from '../images/game-piece-asterisk-D-05.png';
import gamePieceAsteriskD06 from '../images/game-piece-asterisk-D-06.png';
import gamePieceAsteriskD07 from '../images/game-piece-asterisk-D-07.png';
import gamePieceAsteriskD08 from '../images/game-piece-asterisk-D-08.png';
import gamePieceAsteriskE01 from '../images/game-piece-asterisk-E-01.png';
import gamePieceAsteriskE02 from '../images/game-piece-asterisk-E-02.png';
import gamePieceAsteriskE03 from '../images/game-piece-asterisk-E-03.png';
import gamePieceAsteriskE04 from '../images/game-piece-asterisk-E-04.png';
import gamePieceAsteriskE05 from '../images/game-piece-asterisk-E-05.png';
import gamePieceAsteriskE06 from '../images/game-piece-asterisk-E-06.png';
import gamePieceAsteriskE07 from '../images/game-piece-asterisk-E-07.png';
import gamePieceAsteriskE08 from '../images/game-piece-asterisk-E-08.png';
import gamePieceDotA01 from '../images/game-piece-dot-A-01.png';
import gamePieceDotA02 from '../images/game-piece-dot-A-02.png';
import gamePieceDotA03 from '../images/game-piece-dot-A-03.png';
import gamePieceDotA04 from '../images/game-piece-dot-A-04.png';
import gamePieceDotA05 from '../images/game-piece-dot-A-05.png';
import gamePieceDotA06 from '../images/game-piece-dot-A-06.png';
import gamePieceDotA07 from '../images/game-piece-dot-A-07.png';
import gamePieceDotA08 from '../images/game-piece-dot-A-08.png';
import gamePieceDotB01 from '../images/game-piece-dot-B-01.png';
import gamePieceDotB02 from '../images/game-piece-dot-B-02.png';
import gamePieceDotB03 from '../images/game-piece-dot-B-03.png';
import gamePieceDotB04 from '../images/game-piece-dot-B-04.png';
import gamePieceDotB05 from '../images/game-piece-dot-B-05.png';
import gamePieceDotB06 from '../images/game-piece-dot-B-06.png';
import gamePieceDotB07 from '../images/game-piece-dot-B-07.png';
import gamePieceDotB08 from '../images/game-piece-dot-B-08.png';
import gamePieceDotC01 from '../images/game-piece-dot-C-01.png';
import gamePieceDotC02 from '../images/game-piece-dot-C-02.png';
import gamePieceDotC03 from '../images/game-piece-dot-C-03.png';
import gamePieceDotC04 from '../images/game-piece-dot-C-04.png';
import gamePieceDotC05 from '../images/game-piece-dot-C-05.png';
import gamePieceDotC06 from '../images/game-piece-dot-C-06.png';
import gamePieceDotC07 from '../images/game-piece-dot-C-07.png';
import gamePieceDotC08 from '../images/game-piece-dot-C-08.png';
import gamePieceDotD01 from '../images/game-piece-dot-D-01.png';
import gamePieceDotD02 from '../images/game-piece-dot-D-02.png';
import gamePieceDotD03 from '../images/game-piece-dot-D-03.png';
import gamePieceDotD04 from '../images/game-piece-dot-D-04.png';
import gamePieceDotD05 from '../images/game-piece-dot-D-05.png';
import gamePieceDotD06 from '../images/game-piece-dot-D-06.png';
import gamePieceDotD07 from '../images/game-piece-dot-D-07.png';
import gamePieceDotD08 from '../images/game-piece-dot-D-08.png';
import gamePieceDotE01 from '../images/game-piece-dot-E-01.png';
import gamePieceDotE02 from '../images/game-piece-dot-E-02.png';
import gamePieceDotE03 from '../images/game-piece-dot-E-03.png';
import gamePieceDotE04 from '../images/game-piece-dot-E-04.png';
import gamePieceDotE05 from '../images/game-piece-dot-E-05.png';
import gamePieceDotE06 from '../images/game-piece-dot-E-06.png';
import gamePieceDotE07 from '../images/game-piece-dot-E-07.png';
import gamePieceDotE08 from '../images/game-piece-dot-E-08.png';
import lineh01 from '../images/board/line-h-01.png';
import lineh02 from '../images/board/line-h-02.png';
import lineh03 from '../images/board/line-h-03.png';
import lineh04 from '../images/board/line-h-04.png';
import lineh05 from '../images/board/line-h-05.png';
import lineh06 from '../images/board/line-h-06.png';
import lineh07 from '../images/board/line-h-07.png';
import lineh08 from '../images/board/line-h-08.png';
import lineh09 from '../images/board/line-h-09.png';
import lineh10 from '../images/board/line-h-10.png';
import lineh11 from '../images/board/line-h-11.png';
import lineh12 from '../images/board/line-h-12.png';
import lineh13 from '../images/board/line-h-13.png';
import lineh14 from '../images/board/line-h-14.png';
import lineh15 from '../images/board/line-h-15.png';
import lineh16 from '../images/board/line-h-16.png';
import lineh17 from '../images/board/line-h-17.png';
import lineh18 from '../images/board/line-h-18.png';
import lineh19 from '../images/board/line-h-19.png';
import lineh20 from '../images/board/line-h-20.png';
import linev01 from '../images/board/line-v-01.png';
import linev02 from '../images/board/line-v-02.png';
import linev03 from '../images/board/line-v-03.png';
import linev04 from '../images/board/line-v-04.png';
import linev05 from '../images/board/line-v-05.png';
import linev06 from '../images/board/line-v-06.png';
import linev07 from '../images/board/line-v-07.png';
import linev08 from '../images/board/line-v-08.png';
import linev09 from '../images/board/line-v-09.png';
import linev10 from '../images/board/line-v-10.png';
import linev11 from '../images/board/line-v-11.png';
import linev12 from '../images/board/line-v-12.png';
import linev13 from '../images/board/line-v-13.png';
import linev14 from '../images/board/line-v-14.png';
import linev15 from '../images/board/line-v-15.png';
import linev16 from '../images/board/line-v-16.png';
import linev17 from '../images/board/line-v-17.png';
import linev18 from '../images/board/line-v-18.png';
import linev19 from '../images/board/line-v-19.png';
import linev20 from '../images/board/line-v-20.png';


const _imageLibrary = {
  'A': {
    'asterisk': [
      gamePieceAsteriskA01, gamePieceAsteriskA02, gamePieceAsteriskA03,
      gamePieceAsteriskA04, gamePieceAsteriskA05, gamePieceAsteriskA06,
      gamePieceAsteriskA07, gamePieceAsteriskA08,
    ],
    'dot': [
      gamePieceDotA01, gamePieceDotA02, gamePieceDotA03, gamePieceDotA04,
      gamePieceDotA05, gamePieceDotA06, gamePieceDotA07, gamePieceDotA08,
    ],
  },
  'B': {
    'asterisk': [
      gamePieceAsteriskB01, gamePieceAsteriskB02, gamePieceAsteriskB03,
      gamePieceAsteriskB04, gamePieceAsteriskB05, gamePieceAsteriskB06,
      gamePieceAsteriskB07, gamePieceAsteriskB08,
    ],
    'dot': [
      gamePieceDotB01, gamePieceDotB02, gamePieceDotB03, gamePieceDotB04,
      gamePieceDotB05, gamePieceDotB06, gamePieceDotB07, gamePieceDotB08,
    ],
  },
  'C': {
    'asterisk': [
      gamePieceAsteriskC01, gamePieceAsteriskC02, gamePieceAsteriskC03,
      gamePieceAsteriskC04, gamePieceAsteriskC05, gamePieceAsteriskC06,
      gamePieceAsteriskC07, gamePieceAsteriskC08,
    ],
    'dot': [
      gamePieceDotC01, gamePieceDotC02, gamePieceDotC03, gamePieceDotC04,
      gamePieceDotC05, gamePieceDotC06, gamePieceDotC07, gamePieceDotC08,
    ],
  },
  'D': {
    'asterisk': [
      gamePieceAsteriskD01, gamePieceAsteriskD02, gamePieceAsteriskD03,
      gamePieceAsteriskD04, gamePieceAsteriskD05, gamePieceAsteriskD06,
      gamePieceAsteriskD07, gamePieceAsteriskD08,
    ],
    'dot': [
      gamePieceDotD01, gamePieceDotD02, gamePieceDotD03, gamePieceDotD04,
      gamePieceDotD05, gamePieceDotD06, gamePieceDotD07, gamePieceDotD08,
    ],
  },
  'E': {
    'asterisk': [
      gamePieceAsteriskE01, gamePieceAsteriskE02, gamePieceAsteriskE03,
      gamePieceAsteriskE04, gamePieceAsteriskE05, gamePieceAsteriskE06,
      gamePieceAsteriskE07, gamePieceAsteriskE08,
    ],
    'dot': [
      gamePieceDotE01, gamePieceDotE02, gamePieceDotE03, gamePieceDotE04,
      gamePieceDotE05, gamePieceDotE06, gamePieceDotE07, gamePieceDotE08,
    ],
  },
  'board': {
    'lineh': [
      lineh01, lineh02, lineh03, lineh04, lineh05, lineh06, lineh07, lineh08,
      lineh09, lineh10, lineh11, lineh12, lineh13, lineh14, lineh15, lineh16,
      lineh17, lineh18, lineh19, lineh20,
    ],
    'linev': [
      linev01, linev02, linev03, linev04, linev05, linev06, linev07, linev08,
      linev09, linev10, linev11, linev12, linev13, linev14, linev15, linev16,
      linev17, linev18, linev19, linev20,
    ],
  },
};


const _randSeed = Math.floor(Math.random() * 1000000);
const _digest = (state, material) => {
  if (material === null || material === undefined) {
    return state;
  }
  if (typeof material === typeof 0) {
    return state * 29 + (material + 23) * 13;
  }
  if (typeof material === typeof '') {
    for (let i = 0; i < material.length; i++) {
      state = _digest(state, material.charCodeAt(i));
    }
    return state;
  }
  if (Array.isArray(material)) {
    for (let i = 0; i < material.length; i++) {
      state = _digest(state, material[i]);
    }
    return state;
  }
};


const GamePieceHelper = {};

GamePieceHelper.getGamePiece = (style, type, hashMaterial) => {
  let candidates = _imageLibrary[style][type];
  let hash = _digest(_randSeed, hashMaterial) % candidates.length;
  return candidates[hash];
};

GamePieceHelper.getBoardPiece = (type, hashMaterial) => {
  return GamePieceHelper.getGamePiece('board', type, hashMaterial);
};

GamePieceHelper.Type = { ASTERISK: 'asterisk', DOT: 'dot', };


export default GamePieceHelper;
